import {useDispatch, useSelector} from "react-redux";
import {useGoogleOneTapLogin} from "@react-oauth/google";

import {IRPStore} from "../../app/rp_reducer";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {oneTapLogin} from "../api/one_tap_login";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "../tracking/auth_analytics";

interface IProps {
    disable?: boolean;
}

export const useOneTap = (props: IProps = {}) => {
    const isAuthenticated = useSelector((store: IRPStore) => store.isAuthenticated);
    const dispatch = useDispatch();

    const onOneTapLoginSuccess = (isNewUser: boolean) => {
        authAnalytics.gtm.googleAuthEvent(isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN, GAAuthEventCategory.GOOGLE_ONE_TAP);
    };

    const onOneTapLoginError = (error?: unknown) => {
        notifyBugsnag({message: `One tap login error`}, `third-party-login error`, {originalError: error});

        dispatch(addFailureNotification("Coś poszło nie tak. Spróbuj później."));
    };

    useGoogleOneTapLogin({
        onSuccess: async (response) => {
            if (response.credential) {
                oneTapLogin({
                    credential: response.credential,
                    onSuccess: onOneTapLoginSuccess,
                    onError: onOneTapLoginError
                });
            }
        },
        onError: () => {
            onOneTapLoginError("useGoogleOneTapLogin error, login in failure");
        },
        disabled: isAuthenticated || props.disable
    });
};
import {useDispatch, useSelector} from "react-redux";
import {useGoogleOneTapLogin} from "@react-oauth/google";

import {IRPStore} from "../../app/rp_reducer";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {oneTapLogin} from "../api/one_tap_login";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "../tracking/auth_analytics";

interface IProps {
    disable?: boolean;
}

export const useOneTap = (props: IProps = {}) => {
    const isAuthenticated = useSelector((store: IRPStore) => store.isAuthenticated);
    const dispatch = useDispatch();

    const onOneTapLoginSuccess = (isNewUser: boolean) => {
        authAnalytics.gtm.googleAuthEvent(isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN, GAAuthEventCategory.GOOGLE_ONE_TAP);
    };

    const onOneTapLoginError = (error?: unknown) => {
        notifyBugsnag({message: `One tap login error`}, `third-party-login error`, {originalError: error});

        dispatch(addFailureNotification("Coś poszło nie tak. Spróbuj później."));
    };

    useGoogleOneTapLogin({
        onSuccess: async (response) => {
            if (response.credential) {
                oneTapLogin({
                    credential: response.credential,
                    onSuccess: onOneTapLoginSuccess,
                    onError: onOneTapLoginError
                });
            }
        },
        onError: () => {
            onOneTapLoginError("useGoogleOneTapLogin error, login in failure");
        },
        disabled: isAuthenticated || props.disable
    });
};
